<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <!-- <keep-alive include="RentHouseList"> -->
      <router-view />
      <!-- </keep-alive> -->
      <!-- <router-view v-if="!$route.meta.keepAlive" /> -->
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
import Register from './views/user/Register.vue'

export default {
  components: { Register },
  data () {
    return {
      timer: ''
    }
  },
  computed: {
    locale () {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && setDocumentTitle(`${i18nRender(title)} - ${domTitle}`)

      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      if (this.timter) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // console.log(document.documentElement.scrollTop,'document',this.$route.meta.position.y)

        this.$nextTick(() => {
          this.$route.meta.position = { x: window.pageXOffset, y: window.pageYOffset }
        })
        // console.log(this.$route,'8888')
      }, 200)
    })
  }
}
</script>
<style>
/* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: #F5F5F5;
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    border-radius: 10px;
    background-image: -webkit-gradient(linear,left bottom,left top,color-stop(0.44,rgb(60,186,146)),color-stop(0.72,rgb(253,187,45)),color-stop(0.86,rgb(253,187,45)));
    transition: 0.3s ease-in-out;
}
::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
} */

</style>
<style lang="less" scoped>
@map_font_color:rgba(15, 64, 245, 100);
#app {
  background-color: #fff;
}

</style>
<style>
.btn_back{
  /* width:30px;
  height:auto; */
  font-size:24px;
  margin-right:10px;
  color: var(--ThemeColor);
}
.ant-select-dropdown{
  z-index: 9999999999999!important;
}
</style>
